module.exports = __webpack_public_path__ + "static/assets/0d98032547dd0b024d07327c8463f3ad.png";